module.exports = require('./lib/index');



// WEBPACK FOOTER //
// ./~/symbol-observable/index.js